import localAxios from '../localAxios';
import { AccountResponse } from './types';
import { accountURL } from './url';

export async function getAccount() {
  const url = accountURL();
  const response = await localAxios.get<AccountResponse>(url.toString());
  return response.data;
}
